import React, { Component } from 'react';
import 'whatwg-fetch';
import PropTypes from 'prop-types';
import Modal from '../../common/Modal';
import styles from '../PrintModal/PrintModal.module.scss';
import UploadForm from './UploadForm';
import driveIcon from './google-drive.svg';

export default class UploadToDriveModal extends Component {
  static propTypes = {
    assessmentLibrary: PropTypes.bool,
    canToggleLanguage: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    email: PropTypes.string,
    fileName: PropTypes.string.isRequired,
    fileUrl: PropTypes.string.isRequired,
    headerLabel: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    name: PropTypes.string,
    picture: PropTypes.string,
    token: PropTypes.string.isRequired,
  };

  static defaultProps = {
    assessmentLibrary: false,
    email: null,
    name: null,
    picture: null,
  };

  constructor(props) {
    super(props);
    this.state = {};
    this.getFile = this.getFile.bind(this);
    this.fillFileData = this.fillFileData.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  getFile() {
    return this.state.fileData;
  }

  fillFileData() {
    if (this.state.fileData) return;
    this.fetchFileData().then(data => this.setState({ fileData: data }));
  }

  async fetchFileData() {
    let url = this.props.fileUrl;

    if (this.state.locale) url = url.replace(/locale=\w+/, `locale=${this.state.locale}`);

    const response = await fetch(url);
    return response.blob();
  }

  renderLanguageToggle() {
    return (
      <React.Fragment>
        <div className={styles.languageOptionsContainer}>
          {this.renderLanguageButton('en')}
          {this.renderLanguageButton('es')}
        </div>

        <hr />

        <footer>
          <button className="btn btn--link-purple" type="button" onClick={this.closeModal}>Cancel</button>
        </footer>
      </React.Fragment>
    );
  }

  renderLanguageButton(locale) {
    return (
      <button
        className="btn btn--card preserve-color"
        type="button"
        onClick={() => this.setState({ locale })}
      >
        <img alt="" src={driveIcon} />
        {locale === 'en' ? 'English' : 'Spanish'}
      </button>
    );
  }

  closeModal() {
    if (this.props.canToggleLanguage) {
      this.setState({ fileData: null, locale: null }, this.props.closeModal);
    }
    else {
      this.props.closeModal();
    }
  }

  renderUploadForm() {
    return (
      <UploadForm
        assessmentLibrary={this.props.assessmentLibrary}
        closeModal={this.closeModal}
        email={this.props.email}
        fileName={this.props.fileName}
        fileUrl={this.props.fileUrl}
        fillFileData={this.fillFileData}
        getFile={this.getFile}
        locale={this.state.locale}
        name={this.props.name}
        picture={this.props.picture}
        token={this.props.token}
      />
    );
  }

  showLanguageToggle() {
    return !this.state.locale && this.props.canToggleLanguage;
  }

  render() {
    return (
      <Modal
        className={this.showLanguageToggle() ? 'w500' : 'w850'}
        closeModal={this.closeModal}
        headerText={this.props.headerLabel}
        isOpen={this.props.isOpen}
      >
        {this.showLanguageToggle() ? this.renderLanguageToggle() : this.renderUploadForm()}
      </Modal>
    );
  }
}
